export function normalizeNotificationData(data: unknown): unknown {
  if (Array.isArray(data)) {
    return data.map(normalizeNotificationData);
  }

  if (data == null || typeof data !== 'object') {
    return data;
  }

  return Object.fromEntries(Object.entries(data).map(([key, value]) => [toCamelCaseKey(key), normalizeNotificationData(value)]));
}

function toCamelCaseKey(key: string): string {
  return key.replace(/^([A-Z]+)(?=[A-Z][a-z]|$)/, match => match.toLowerCase()).replace(/^[A-Z]/, character => character.toLowerCase());
}
